import Rpc from "@/Rpc";
import DialogManager from "@/utils/DialogManager";
import FormsLoader from "@/components/forms/FormsLoader";
import {AUTOCONF_MODULES, AUTOCONF_TEMPLATES} from "@/utils/Modules";

const ActivityManager = () => require("@/activity/ActivityManager");
const InviteActivity = () => require("@/components/invitations/InvitationActivity.vue");


// https://localhost:8443/dashboard/invite?token=LOTeEqmNOfqhSWJYtkGEmu.gpl3CA1X4J1GB3N-ILFAS0W9.3x9mT8RS6ZV1-8Sd.O3pt3EAqxX5ehE91Th08Q

export function checkPreConf() {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const autoconf = params.get('autoconf')
    if (autoconf && AUTOCONF_MODULES[autoconf]) {
        localStorage.setItem('autoconf', autoconf);
        return;
    }

    localStorage.removeItem('autoconf');
}

export function getAutoconfModules(){
    let autoconf =  localStorage.getItem("autoconf");
    return AUTOCONF_MODULES[autoconf];
}

export function getAutoconfTemplate(){
    let autoconf =  localStorage.getItem("autoconf");
    if(!autoconf){
        return "default";
    }
    return AUTOCONF_TEMPLATES[autoconf] ?? "default";
}

export function hasAutoconf() {
    return !!localStorage.getItem("autoconf");
}

export function checkInvite() {
    if (!window.location.pathname.includes("/invite")) {
        resetInvite();
        return;
    }
    const url = new URL(window.location.href);
    const token = new URLSearchParams(url.search).get("token");
    if (!token) {
        return;
    }

    localStorage.setItem('pendingInvite', token);
}

export function hasPendingInvite() {
    return !!localStorage.getItem("pendingInvite");
}

export function resetInvite() {
    localStorage.removeItem("pendingInvite");
}

export function getInviteToken() {
    return localStorage.getItem("pendingInvite");
}

export async function getInviteInfo() {
    let token = localStorage.getItem("pendingInvite");
    if (!token) {
        return null;
    }
    let res = Rpc.Invitations.invitationInfo(token);
    if (!res) {
        resetInvite();
    }
    return res;
}

export async function acceptInviteAsExistingContact(supplierId) {
    let token = localStorage.getItem("pendingInvite");
    await Rpc.Invitations.acceptInvitation(token, supplierId);
    resetInvite()
}

export async function acceptInviteAsNewContact() {
    let token = localStorage.getItem("pendingInvite");
    await Rpc.Invitations.acceptAsNew(token);
    resetInvite()
}

export async function connectInvitationToContact() {
    let tInfo = await getInviteInfo();
    if (!tInfo) {
        return;
    }

    // let form = FormsLoader.detectFormConfig(this.formClass);
    // this.hasAccessToList = form.restrictedList ? SessionManager.hasPermission(form.effectivePermissionList): true;

    if (SessionManager.freshlyCreatedOrg) {
        await acceptInviteAsNewContact();
        await DialogManager.infoNewOrganization($tr("InvitationAccepted","Invitation accepted"),
            $tr("invites.information","Now you can exchange information with organization #{1}",tInfo.companyName));
    } else {
        let am = await ActivityManager();
        let activity = await am.default.showActivity(await InviteActivity(), {invitationInfo: tInfo});
        let res = await activity.getResult();
        if (res) {
            await acceptInviteAsNewContact();
            await DialogManager.infoNewOrganization($tr("InvitationAccepted","Invitation accepted"),
                $tr("invites.information","Now you can exchange information with organization #{1}",tInfo.companyName));
        } else {
            await resetInvite();
        }
    }
}
